import Alert from '@/storybook/components/Alert/Alert';
import Text from '@/storybook/components/Text/Text';
import styles from './DEInsightsDisclaimer.module.css';
import { useTranslation } from 'react-i18next';

const DEInsightsDisclaimer = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'header.DEInsightsDisclaimer' });
  return (
    <Alert variant="warning" message={t('title')} className={styles.disclaimer}>
      <Text className={styles.text}>{t('purpose')}</Text>
      <Text className={styles.text}>{t('details')}</Text>
      <Text className={styles.text}>{t('content')}</Text>
      <Text className={styles.text}>{t('contacts')}</Text>
    </Alert>
  );
};

export default DEInsightsDisclaimer;
